import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ChevronRight, Globe } from "lucide-react";

const ProductSearchList = ({ products = [], onProductClick }) => {
    const { t } = useTranslation();

    const handleFoodbook = async (e, product) => {
        e.preventDefault();
        e.stopPropagation();

        window.open(`https://psinfoodservice.com/product/${product.id}-/`, '_blank'); //${encodeURIComponent(product.name)}
    }

    return (
        <div className="space-y-2">
            {Array.isArray(products) && products.map((product) => (
                <div
                    key={product.id}
                    className="flex items-center justify-between w-full p-4 hover:pl-6 cursor-pointer border-b-[1px]"
                    onClick={() => onProductClick(product)}
                >
                    <span className="font-inter">{product.name}</span>
                    <div className="flex items-center gap-4">
                        {product.brand !== 'Vers' && (
                            <Globe 
                                className="text-ps-blue-dark" 
                                size={20} 
                                onClick={(e) => handleFoodbook(e, product)}
                                title={t('products.openFoodbook') || 'Open in Foodbook'}
                            />
                        )}
                        <ChevronRight 
                            className="text-ps-blue-dark" 
                            size={20}
                            aria-label={t('common.viewDetails') || 'View details'}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
};

ProductSearchList.propTypes = {
    products: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            type: PropTypes.oneOf(['bought', 'homemade']).isRequired,
        })
    ),
    onProductClick: PropTypes.func.isRequired
};

export default ProductSearchList;